import type { FigmaIconProps } from './types';

export const IconFigmaHome = ({ size = 16, color = 'currentColor' }: FigmaIconProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M13.3997 6.29297L8 2.0931L2.60026 6.29297V13.3333C2.60026 13.5278 2.67758 13.714 2.8151 13.8516C2.95263 13.9891 3.13884 14.0664 3.33333 14.0664H12.6667C12.8612 14.0664 13.0474 13.9891 13.1849 13.8516C13.3224 13.714 13.3997 13.5278 13.3997 13.3333V6.29297ZM14.6003 13.3333C14.6003 13.8461 14.3964 14.338 14.0339 14.7005C13.6713 15.0631 13.1794 15.2669 12.6667 15.2669H3.33333C2.82058 15.2669 2.32872 15.0631 1.96615 14.7005C1.60358 14.338 1.39974 13.8461 1.39974 13.3333V6C1.39974 5.81494 1.4855 5.64037 1.63151 5.52669L7.63151 0.860026C7.84818 0.691508 8.15182 0.691508 8.36849 0.860026L14.3685 5.52669C14.5145 5.64037 14.6003 5.81494 14.6003 6V13.3333Z"
      fill={color}
    />
    <path
      d="M9.39974 14.6667V8.60026H6.60026V14.6667C6.60026 14.998 6.33137 15.2669 6 15.2669C5.66863 15.2669 5.39974 14.998 5.39974 14.6667V8C5.39974 7.66863 5.66863 7.39974 6 7.39974H10C10.3314 7.39974 10.6003 7.66863 10.6003 8V14.6667C10.6003 14.998 10.3314 15.2669 10 15.2669C9.66863 15.2669 9.39974 14.998 9.39974 14.6667Z"
      fill={color}
    />
  </svg>
);
